// [claude] Promoted to shared/FormInput.jsx (2026-07 Ink design system) so the same
// input renders on every surface; this re-export keeps the OAuth/SSO import paths
// stable. Do not add styles here.
export { default } from '../../../shared/FormInput';
